import Slider from '@common/models/Slider';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface SliderSliceType {
  slider?: SliderResponseType;
  isFetching: boolean;
  isFetched: boolean;
  error: string;
}

export interface SliderResponseType {
  count: number;
  next: string | null;
  previous: string | null;
  results: Slider[];
}

const sliderSlice = createSlice({
  name: 'slider',
  initialState: <SliderSliceType>{
    slider: null,
    isFetching: false,
    isFetched: false,
    error: '',
  },
  reducers: {
    fetchSliderRequest(state) {
      state.isFetching = true;
      state.isFetched = false;
      state.slider = null;
      state.error = '';
    },
    fetchSliderSuccess(state, { payload }: PayloadAction<SliderResponseType>) {
      state.slider = payload;
      state.isFetching = false;
      state.isFetched = true;
    },
    fetchSliderFailure(state, { payload }: PayloadAction<string>) {
      state.error = payload;
      state.isFetching = false;
      state.isFetched = true;
    },
  },
});

export const { fetchSliderSuccess, fetchSliderRequest, fetchSliderFailure } = sliderSlice.actions;

export default sliderSlice.reducer;
